import { Injectable } from '@angular/core';
import { PaymentMethodName } from '../../enums/payment/payment-method-name';
import { TransactionData } from '../../interfaces/transaction/transaction-data';

@Injectable({
  providedIn: 'root'
})
export class TransactionToTransactionViewDataMapperService {

  /**
   * map transaction data from backend-response to transactions-view-table
   * @param transactionData
   */
  public map(transactionData: TransactionData): TransactionData {
    transactionData.IconTitle = transactionData.paymentMethod;

    switch (transactionData.paymentMethod) {
      case PaymentMethodName.CREDITCARD:
        transactionData.icon = 'pi pi-credit-card';
        transactionData.customIcon = false;
        break;
      case PaymentMethodName.CREDITCARD_MOTO:
        transactionData.icon = 'creditcard_moto';
        transactionData.customIcon = true;
        break;
      case PaymentMethodName.WERO:
        transactionData.icon = 'wero';
        transactionData.customIcon = true;
        break;
      case PaymentMethodName.SEPA:
        transactionData.icon = 'sepa';
        transactionData.customIcon = true;
        break;
      case PaymentMethodName.SEPA_BLACKLIST:
        transactionData.icon = 'sepa_blacklist';
        transactionData.customIcon = true;
        break;
      case PaymentMethodName.KLARNA:
        transactionData.icon = 'klarna';
        transactionData.customIcon = true;
        break;
      case PaymentMethodName.DIRECTTRANSFER:
        transactionData.icon = 'directtransfer';
        transactionData.customIcon = true;
        break;
      case PaymentMethodName.PAYPAL:
        transactionData.icon = 'pi pi-paypal';
        transactionData.customIcon = false;
        break;
      case PaymentMethodName.APPLEPAY:
        transactionData.icon = 'pi pi-apple';
        transactionData.customIcon = false;
        break;
      case PaymentMethodName.GOOGLEPAY:
        transactionData.icon = 'pi pi-google';
        transactionData.customIcon = false;
        break;
    }
    return transactionData;
  }
}
